import { InlineIcon } from '@iconify/react';
import { TextArea, TextAreaChangeEvent } from '@progress/kendo-react-inputs';
import { FC, useCallback, useMemo } from 'react';
import useConfirm from 'src/hooks/useConfirm';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { getIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';

interface NotesProps {
  notes: string;
  name: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  errors: string[];
}

const Notes: FC<NotesProps> = ({ notes, onChange, name, disabled, errors }) => {
  const { confirm } = useConfirm();
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );

  const handleChange = useCallback(
    (e: TextAreaChangeEvent) => {
      onChange(e.value);
    },
    [onChange]
  );

  const NotesContent = useMemo(
    () => (
      <div className="min-w-[300px]">
        <p> {name} Notes </p>
        <TextArea
          defaultValue={notes}
          onChange={handleChange}
          disabled={isInvoiceEditDisabled || disabled}
        />
      </div>
    ),
    [disabled, handleChange, isInvoiceEditDisabled, name, notes]
  );

  const handleConfirm = useCallback(() => {
    confirm({
      title: `${name} notes`,
      content: NotesContent,
      cancelButtonText: 'Close',
      cancelColor: 'info',
      hasNoConfirmButton: true,
    });
  }, [NotesContent, confirm, name]);

  return (
    <div className="p-1 text-[13px]">
      <p className="flex flex-row gap-1 items-center justify-between font-bold mb-1">
        <span className="flex items-center">
          {name} Notes
          <InlineIcon
            icon="material-symbols:edit-square-outline-rounded"
            onClick={handleConfirm}
            className="cursor-pointer"
          />
        </span>
        <span>{getIcon(errors)}</span>
      </p>
      <p className="line-clamp"> {notes} </p>
    </div>
  );
};
export default Notes;
